import styled from "styled-components";

// No border/padding of its own: the Summary tab's sections and the PAIC
// preview's strip (PreviewBridgeStripStyled) each frame it.
export const BridgeRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CardStyled = styled.div`
  flex: 1;
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  border-radius: 8px;
  padding: 3px 14px;
  text-align: center;
  background: ${(p) => p.$bg || "#fff"};
`;

// $accentToken resolves through the theme (same tokens the Legend/tree
// nodes use via getRoleChangeConfig) — $color stays a literal hex, for the
// bridge cards above that already use fixed colors unrelated to status.
export const NumStyled = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${(p) => (p.$accentToken ? p.theme?.colors?.[p.$accentToken] : p.$color) || "#202124"};
  line-height: 1.1;
`;

export const LabelStyled = styled.div`
  font-size: 11.5px;
  color: #5a6a7a;
  margin-top: 1px;
`;

export const SubStyled = styled.span`
  display: block;
  font-size: 11.5px;
  color: #9ca3af;
`;

export const OpStyled = styled.div`
  font-size: 19px;
  color: #9ca3af;
  font-weight: 600;
  flex-shrink: 0;
`;
